import { render, staticRenderFns } from "./ContactLeadTeam.vue?vue&type=template&id=018fbce0&scoped=true"
import script from "./ContactLeadTeam.vue?vue&type=script&lang=js"
export * from "./ContactLeadTeam.vue?vue&type=script&lang=js"
import style0 from "./ContactLeadTeam.vue?vue&type=style&index=0&id=018fbce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018fbce0",
  null
  
)

export default component.exports